<template>
  <div id="tableCacheWrapper">
    <div class="notification" v-if="cache.length === 0">Geen tijdelijk opgeslagen tabellen gevonden</div>

    <table
      v-else
      class="table is-striped is-bordered">

      <thead>
        <tr>
          <th></th>
          <th
            v-for="table in tables"
            :key="table.id">

            {{ table.name }}
          </th>
        </tr>
      </thead>

      <tbody>
        <tr
          v-for="bundle in cache"
          :key="bundle.id">

          <th>{{ bundle.name }}</th>

          <td
            v-for="table in bundle.cache"
            :key="table.id"
            :title="bundle.name + ' | ' + getTableName(table.id)"
            @click="(table.result <= 0) ? refresh(table.id, bundle.id) : null">

            <span
              v-show="table.result !== -1"
              class="icon"
              :class="getStatusColor(table.result)">
              <i :class="getStatusMark(table.result)"></i>
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'TableCache',
  data () {
    return {
      statusMarks: [
        'fas fa-times',
        'far fa-circle',
        'fas fa-check'
      ],
      statusColors: [
        'has-text-danger',
        'has-text-warning',
        'has-text-success'
      ]
    }
  },
  computed: {
    ...mapGetters({
      tables: 'tables/tables',
      cache: 'tableCache/cache'
    })
  },
  created () {
    this.$store.dispatch('tableCache/load')
  },
  methods: {
    getStatusMark (statusCode) {
      return this.statusMarks[statusCode]
    },
    getStatusColor (statusCode) {
      return this.statusColors[statusCode]
    },
    getTableName (tableId) {
      if (this.tables.length > 0) {
        return this.tables.find(x => x.id === tableId).name
      }
    },
    refresh (tableId, bundleId) {
      this.$store.dispatch('tables/refresh', {
        tableId: tableId,
        bundleId: bundleId
      })
    }
  }
}
</script>

<style lang="css">
</style>
